import { render } from "./FindTheShape.vue?vue&type=template&id=c3297150&scoped=true"
import script from "./FindTheShape.vue?vue&type=script&lang=js"
export * from "./FindTheShape.vue?vue&type=script&lang=js"

import "./FindTheShape.vue?vue&type=style&index=0&id=c3297150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3297150"]])

export default __exports__